import OMS from "../assets/images/oms.svg";
import OMSDark from "../assets/images/trading-dark.svg";
import AccountOpening from "../assets/images/account-opening.svg";
import AccountOpeningDark from "../assets/images/account-opening-dark.svg";
import FundsApproval from "../assets/images/funds-approval.svg";
import FundsApprovalDark from "../assets/images/funds-approval-dark.svg";
import FixSpecifications from "../assets/images/fix.svg";
import FixSpecificationsDark from "../assets/images/fix-dark.svg";
import JournalAPI from "../assets/images/journal-api.svg";
import JournalAPIDark from "../assets/images/journal-api-dark.svg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    key: 1,
    name: "Account Opening API",
    description: "Onboard new users",
    image: AccountOpening,
    imageDark: AccountOpeningDark,
    route: "/products/account-opening-api",
    link: "https://github.com/VCT-Technologies-LLC/AccountOpeningSample",
    apis: [
      {
        name: "Fund Request",
        endpoint: "/api/fundsapproval/fundrequest",
        method: "POST",
        parameters: {
          FirstName: "string",
          LastName: "string",
          AccountName: "string",
          Account: "number",
          BackOfficeAccountNumber: "string",
          ABA: "number",
          AccountTypeId: "number",
          Address: "string",
          CountryId: "number",
          StateId: "number",
          Apt: "string",
          City: "string",
          ZipCode: "number",
          IsDefault: "boolean",
          Action: "string",
          Requestee: "string",
          Amount: "number",
          RequestTypeId: "number",
          TransactionTypeId: "number",
          PlaidToken: "string",
        },
      },
    ],
    url: "",
  },
  {
    key: 2,
    name: "Funding API",
    description: "Custom workflows",
    image: FundsApproval,
    imageDark: FundsApprovalDark,
    route: "/products/funding-api",
    link: "https://github.com/VCT-Technologies-LLC/FundingSample",
  },
  {
    key: 3,
    name: "Trading API",
    description: "Trade equities, options, monitor positions",
    image: OMS,
    imageDark: OMSDark,
    route: "/products/trading-api-v6.0",
    link: "https://github.com/VCT-Technologies-LLC/TradingSample",
  },
  {
    key: 4,
    name: "FIX Specifications",
    description: "Harness the power of our low latency",
    image: FixSpecifications,
    imageDark: FixSpecificationsDark,
    route: "/products/fix-specifications-v3.9",
    link: "",
  },
  {
    key: 5,
    name: "Journal API",
    description: "asd",
    image: JournalAPI,
    imageDark: JournalAPIDark,
    route: "/products/journal-api",
    link: "",
  },
];
